import { useI18n } from '@ecom/i18n';
import { type ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthLayout } from './AuthLayout';

import { useSession } from '@/lib/session';

/**
 * Shown instead of the merchant space when the signed-in account belongs to the OTHER space (a platform account with no shop). One sign-in serves both
 * spaces (a single account system) and the server refuses every merchant call of such an account anyway: this screen says so in
 * words rather than leaving an empty shell full of 403s. It decides nothing: the server stays the barrier.
 */
export function WrongSpaceNotice(): ReactElement {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { clearSession } = useSession();

  return (
    <AuthLayout
      title={t('auth.wrongSpace.merchant.title')}
      subtitle={t('auth.wrongSpace.merchant.subtitle')}
      footer={
        <button
          type="button"
          className="font-medium text-accent hover:underline"
          onClick={() => {
            clearSession();
            void navigate('/login', { replace: true });
          }}
        >
          {t('auth.changePassword.signOut')}
        </button>
      }
    >
      <p role="alert" className="rounded-md bg-surface2 px-3 py-2 text-sm text-inkSoft">
        {t('auth.wrongSpace.merchant.body')}
      </p>
    </AuthLayout>
  );
}
